import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import Education from "./Education";
import AboutPage from "./AboutPage";
import Projects from "./Projects";
import Skills from "./Skills";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Timeline from "./Timeline";

function Main() {
  // console.log(location)
  const HomePage = () => {
    return <Home />;
  };
  const EducationPage = () => {
    return <Timeline />;
  };
  const About = () => {
    return <AboutPage />;
  };
  const Project = () => {
    return <Projects />;
  };
  const Skill = () => {
    return <Skills />;
  };
  return (
    <>
      <div>
        <Route
          render={({ location }) => (
            <TransitionGroup>
              <CSSTransition key={location.key} classNames="page" timeout={500}>
                <Switch>
                  <Route path="/home" component={HomePage} />
                  <Route exact path="/project" component={Project} /> */
                  <Route exact path="/education" component={EducationPage} />
                  <Route exact path="/about" component={About} />
                  <Route exact path="/skill" component={Skill} />
                  <Redirect to="/home" />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          )}
        />
      </div>
    </>
  );
}

export default Main;
